<template>
  <div class="p-4">
    <ServiceRequestCard
        v-for="request in serviceRequests"
        :key="request.id"
        :serviceRequest="request"/>

  </div>
</template>

<script>
import {getServiceRequests} from "@/API/API";
import ServiceRequestCard from "@/components/User/ServiceRequestCard";

export default {
  name: "ServiceRequest",
  components: {ServiceRequestCard},
  data() {
    return {
      serviceRequests: []
    }
  },
  async created() {
    this.serviceRequests = (await getServiceRequests()).data
  }
}
</script>

<style scoped>

</style>